import { render, staticRenderFns } from "./discountConfig.vue?vue&type=template&id=2c233d28&scoped=true&"
import script from "./discountConfig.vue?vue&type=script&lang=js&"
export * from "./discountConfig.vue?vue&type=script&lang=js&"
import style0 from "./discountConfig.vue?vue&type=style&index=0&id=2c233d28&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c233d28",
  null
  
)

export default component.exports